import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'a[pxc-sidebar-link]',
  template: '<ng-content />',
  styleUrl: './sidebar-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    // An open group (`tui-link-active`) and the displayed page (`tui-link-current`) are tinted; Tailwind emits the
    // displayed page's tint last, so it wins over the hover and the open group's.
    class:
      'flex! items-center! gap-3! rounded-xl! px-3! py-2! text-text-tertiary! hover:bg-background-active! ' +
      '[&.tui-link-active]:bg-background-primary-alt! [&.tui-link-active]:text-text-primary! ' +
      '[&.tui-link-current]:bg-background-secondary!',
    '[attr.data-collapsed]': 'collapsed()',
  },
})
export class SidebarLinkComponent {
  readonly collapsed = input(false);
}
